import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnDestroy{
  title = 'angular-starter';
  version = 'Angular version 11.2.3';

  constructor(
    public router: Router,
    ) {
    }

  ngOnDestroy() {
  }
}

